<div class="modal-header">
  <h4 class="modal-title pull-left">회원수정</h4>
  <button type="button"
    class="btn-close close pull-right"
    aria-label="Close"
    (click)="modalService.hide()">
    <span aria-hidden="true"
      class="visually-hidden">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="card">
    <div class="card-body">
      <div class="table-responsive"
        *ngIf="userData">
        <table class="table table-nowrap mb-0">
          <tbody>
            <tr>
              <th scope="row">가입일 :</th>
              <td>{{ userData.created_at | date : "yyyy.MM.dd" }}</td>
            </tr>
            <tr>
              <th scope="row">회원이름 :</th>

              <td>
                <input class="form-control"
                  id="name"
                  placeholder="회원이름"
                  [(ngModel)]="userData.name" />
              </td>
            </tr>
            <tr>
              <th scope="row">이메일주소 :</th>
              <td>{{ userData.email }}</td>
            </tr>
            <tr>
              <th scope="row">가입경로 :</th>
              <td>{{ userData.signup_type }}</td>
            </tr>
            <tr>
              <th scope="row">회원종류 :</th>
              <td>
                {{
                isPastDate(userData.premium) ? "일반 회원" : "프리미엄 회원"
                }}
              </td>
            </tr>
            <tr>
              <th scope="row">회원상태 :</th>
              <td>
                <ng-container *ngIf="userData.restrict === '활동회원'">
                  {{ userData.restrict }}
                </ng-container>
                <ng-container *ngIf="userData.restrict === '탈퇴회원'">
                  {{ userData.restrict }} (탈퇴일
                  {{ withdrawalData?.created_at | date : "yyyy.MM.dd" }})
                  <button (click)="modalReason.show()"
                    class="btn btn-sm btn-soft-primary">
                    탈퇴 사유
                  </button>
                </ng-container>
              </td>
            </tr>
            <tr>
              <th scope="row">성별 :</th>
              <td>
                <select class="form-select"
                  [(ngModel)]="userData.sex">
                  <option value="">미선택</option>
                  <option value="MALE">남</option>
                  <option value="FEMALE">여</option>
                  <option value="NONE">없음</option>
                </select>
              </td>
            </tr>

            <tr>
              <th scope="row">국가 :</th>
              <td>
                <select class="form-select"
                  [(ngModel)]="userData.country">
                  <option value="">미선택</option>
                  <option *ngFor="let co of country"
                    [value]="co.korean">
                    {{ co.korean }}
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th scope="row">연령대 :</th>

              <td>
                <select class="form-select"
                  [(ngModel)]="userData.age">
                  <option value="">미선택</option>
                  <option *ngFor="let ag of ages"
                    [value]="ag">
                    {{ ag }}대
                  </option>
                </select>
              </td>
            </tr>
            <tr>
              <th scope="row">마케팅 알림 동의 :</th>
              <td>{{ userData.app_marketing ? "동의" : "미동의" }}</td>
            </tr>
            <tr>
              <th scope="row">보유 코인 :</th>
              <td>{{ userData.coin }}</td>
            </tr>
            <!-- <tr *ngIf="!isPastDate(userData.premium)">
              <th scope="row">프리미엄 구독 만료일 :</th>
              <td>{{ userData.premium | date : "yyyy.MM.dd" }}</td>
            </tr> -->
            <tr>
              <th scope="row">레벨 :</th>
              <td>{{ userData.upper_level }}</td>
            </tr>
            <tr>
              <th scope="row">추천인 아이디 :</th>
              <td>
                {{ userData.recommender ? userData.recommender : "없음" }}
              </td>
            </tr>
            <tr>
              <th scope="row">추천 받은 횟수 :</th>
              <td>{{ userData.count_recommender }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button"
    class="btn btn-default"
    (click)="saveUser()">
    수정
  </button>
</div>

<div bsModal
  #modalReason
  id="modalReason"
  class="modal fade bs-example-modal-lg"
  tabindex="-1"
  role="dialog"
  aria-labelledby="myLargeModalLabel"
  aria-hidden="true">
  <div class="modal-dialog modal-lg modal-dialog-centered">
    <!-- 여기에 modal-dialog-centered 추가 -->
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title add-task-title">탈퇴사유</h5>
        <button type="button"
          class="btn-close"
          (click)="modalReason.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="card mb-4">
            <div class="card-body">
              <div class="form-group mb-3"
                *ngIf="withdrawalData">
                <label for="taskname"
                  class="col-form-label">선택사유<span class="text-danger"></span></label>
                <div class="col-lg-12">
                  <input id="taskname"
                    name="taskname"
                    type="text"
                    class="form-control validate"
                    [(ngModel)]="withdrawalData.reason_type"
                    disabled />
                </div>
              </div>
              <div class="form-group mb-3"
                *ngIf="withdrawalData">
                <label class="col-form-label">상세사유</label>
                <div class="col-lg-12">
                  <textarea id="taskdesc"
                    class="form-control"
                    name="taskdesc"
                    disabled
                    [(ngModel)]="withdrawalData.reason"></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end row-->

        <div class="row">
          <div class="text-end mb-4">
            <button type="submit"
              (click)="modalReason.hide()"
              class="btn btn-primary">
              닫기
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- /.modal-content -->
  </div>
  <!-- /.modal-dialog -->
</div>
<!-- /.modal -->
